import { useNavigate, useParams } from 'react-router-dom';
import estilos from './ItemPage.module.css';

function ItemPage(props) {
    const parametros = useParams();
    const navigate = useNavigate();

    const item = props.dados.find((elemento) => elemento.id === Number(parametros.id));

    if (!item) {
        return navigate("/");
    }

    return (
        <div className={estilos.container}>
        <div className={estilos.card}>
            <img src={item.image} alt={`Imagem do personagem ${item.name}`} />
            <div>
                <h1>{item.name}</h1>
                <h2>{item.description}</h2>

                <div className={estilos.informacoes}>
                    <div className={estilos.infoItem}>
                        <h3>Raça</h3>
                        <h4>{item.race}</h4>
                    </div>

                    <div className={estilos.infoItem}>
                        <h3>Gênero</h3>
                        <h4>{item.gender}</h4>
                    </div>

                    <div className={estilos.infoItem}>
                        <h3>Base KI</h3>
                        <h4>{item.ki}</h4>
                    </div>

                    <div className={estilos.infoItem}>
                        <h3>Total KI</h3>
                        <h4>{item.maxKi}</h4>
                    </div>

                    <div className={estilos.infoItem}>
                        <h3>Afiliação</h3>
                        <h4>{item.affiliation}</h4>
                    </div>
                </div>

            </div>
        </div>
        <button onClick={() => navigate('/personagens')} className={estilos.botao}>Voltar</button>
        </div>
    )
}

export default ItemPage;